import { Checkbox, Col, Divider, Row, Typography } from "antd";
import React from "react";
import { formatDateInMMDDYYYY } from "../../../helpers/date";
import UserDropDown from "../user-items/UserDropDown";
import ChatIcon from "./../../../graphics/svgs/chatIcon.svg";
import "./dashboardcard.css";
import { formatAddress } from "../../../helpers/viewUsersConstants";
const UsersItemCard: React.FC<UserMobileCard> = ({ user }) => {
  return (
    <>
      <div className="dashboard-item-card">
        <Row className="dashboard-card-single-item-container">
          <Col className="checkbox-dashboard-item mb-10" span={24}>
            <Checkbox />
            <img src={ChatIcon} style={{ width: "25px", cursor: "pointer" }} />
            {/* <img
              src={ThreeDotsHrz}
              style={{ width: "25px", cursor: "pointer" }}
            /> */}
            <UserDropDown
              userId={user._id}
              fullName={user.firstName + " " + user.lastName}
            />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Customer
            </Typography>

            <Typography className="users-table-customer-name">
              {user.firstName} {user.lastName}{" "}
            </Typography>
            <Typography className="users-table-customer-phone">
              {user.phoneNumber || ""}
            </Typography>
            <Typography className="users-table-customer-phone">
              {user.email}
            </Typography>
            <Divider />
          </Col>

          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Address
            </Typography>

            <Typography className="users-table-generic-label">
              {/* 100 Twinge Lane apt #290 New York, NY 10001 */}
              {formatAddress(user.address)}
            </Typography>
            <Divider />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Date Signed Up
            </Typography>

            <Typography className="users-table-generic-label">
              {formatDateInMMDDYYYY(new Date(user.createdAt), true)}
            </Typography>
            <Divider />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Date of last order
            </Typography>

            <Typography className="users-table-generic-label">
              {user.latestOrder
                ? formatDateInMMDDYYYY(
                    new Date(user.latestOrder.createdAt),
                    true
                  )
                : "---"}
            </Typography>
            <Divider />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Formula
            </Typography>

            <Typography className="users-table-generic-label">
              {user.latestOrder && user.latestOrder.formulaDetails
                ? user.latestOrder.formulaDetails.activeIngredients +
                  "," +
                  user.latestOrder.formulaDetails.creamBase
                : "---"}
            </Typography>
            <Divider />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Order Status
            </Typography>
            {user.latestOrder ? (
              <Typography className="order-prescribed-tag">
                {user.latestOrder.processingDetails.orderStatus}
              </Typography>
            ) : (
              "---"
            )}
            {/* <Typography className="order-prescribed-tag">Prescribed</Typography> */}
          </Col>
          {/* <Col span={24} className="checkbox-dashboard-item">
            <img src={ChatIcon} style={{ width: "25px", cursor: "pointer" }} />
            <img
              src={ThreeDotsHrz}
              style={{ width: "25px", cursor: "pointer" }}
            />
          </Col> */}
        </Row>
      </div>
    </>
  );
};

export default UsersItemCard;
